import Server from "../server";
import View from "../framework/view";
import template from "../../pugc/number";
import {ListOrdersNotification, ViewOrderNotification} from "./wrb";
import jQuery from "jquery";
import {ListOrdersView} from "./list_orders";

export class NumberView extends View {

    static classname = "number-view";

    private readonly server = Server.instance();

    private baseUrl?: string;

    constructor() {
        super(NumberView.classname);
        this.server.getShortBaseUrl().then((url) => {
            this.baseUrl = url;
            this.update();
        });
    }

    protected render0(): JQuery<HTMLElement> {

        if (! this.baseUrl) {
            return jQuery("<div>Loading</div>");
        }

        const data = {
        };

        const out = this.pug(template, data);

        return out;
    }

    async find() {
        const n = this.elt().find("input[name='orderNumber']").val() as string;
        const orders = await this.server.getOrdersByNumber(n);
        if (orders.length == 1) {
            this.notify(new ViewOrderNotification(orders[0].id as string));
        } else {
            const ids = orders.map(order => order.id as string);
            this.notify(new ListOrdersNotification(ids));
        }
    }

}

View.on(
    "." + NumberView.classname,
    "click",
    ".find",
    function(that: NumberView, event, elt) {
        event.preventDefault();
        that.find();
    });

